import { render, staticRenderFns } from "./OverDuesRow.vue?vue&type=template&id=510ef1d4"
import script from "./OverDuesRow.vue?vue&type=script&lang=js"
export * from "./OverDuesRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports